import React from "react";
import { Text } from "@sitecore-jss/sitecore-jss-react";
const StartingStep = ({
  proceedToNextStep,
  fields
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    tag: "h2",
    className: "account__header",
    field: fields.StartingStepTitle
  }), /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "account__description",
    field: fields.StartingStepDescription
  }), /*#__PURE__*/React.createElement("button", {
    className: "btn account__btn",
    onClick: proceedToNextStep
  }, fields.StartingStepCTAText?.value));
};
export default StartingStep;